import React from 'react';

import {getLocalizedStrings} from '@/services/localization/localizationService';

const WeCare = ({titleKey, descriptionKey, className}) => {
    const localizedStrings = getLocalizedStrings();

    return (
        <article className={className}>
            <div className='flex flex-col gap-2 rounded-lg bg-primary-dark-5 p-6'>
                <h2 className='m-0 text-20 font-bold leading-[24px]'>{localizedStrings[titleKey]}</h2>
                <p className='text-14 leading-[20px] tracking-02'>{localizedStrings[descriptionKey]}</p>
            </div>
        </article>
    );
};

export default WeCare;
